// src/pages/home/Home.tsx
import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { RouteDefine } from '../../routes/index.tsx/RouteDefine';
import { Layout } from '../../components/layout';
import { 
  CustomerPanel,
  SupplierPanel,
  ProductPanel,
  FinancePanel,
  AccountingPanel,
  StateOfAccountPanel
} from './tab';
import ConnectionInfo from './ConnectionInfo';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Home: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };


  return (
    <Layout>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label="basic tabs example" sx={{ px: 3 }}>
          <Tab label="Accounting" {...a11yProps(0)} />
            <Tab label="Customer" {...a11yProps(1)} />
            <Tab label="Supplier" {...a11yProps(2)} />
            <Tab label="Product" {...a11yProps(3)} />
            <Tab label="Finance" {...a11yProps(4)} />
            <Tab label="State Of Account" {...a11yProps(5)} />
            <Tab label="Connection Info" {...a11yProps(6)} />
          </Tabs>
        </Box>
        <Box sx={{ minHeight: '400px' }}>
        <TabPanel value={tabValue} index={0}>
            <AccountingPanel />
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <CustomerPanel />
          </TabPanel>
          <TabPanel value={tabValue} index={2}>
            <SupplierPanel />
          </TabPanel>
          <TabPanel value={tabValue} index={3}>
            <ProductPanel />
          </TabPanel>
          <TabPanel value={tabValue} index={4}>
            <FinancePanel />
          </TabPanel>
          <TabPanel value={tabValue} index={5}>
            <StateOfAccountPanel />
          </TabPanel>
          <TabPanel value={tabValue} index={6}>
            <ConnectionInfo />
          </TabPanel>
        </Box>
      </Box>
    </Layout>
  );
};

export default Home;
